var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapseMessageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.532,
    height: 13.522,
    viewBox: "0 0 19.532 19.522",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_15c2390bc87bdefed6fb5b29f8089e8e",
    "data-name": "15c2390bc87bdefed6fb5b29f8089e8e",
    d: "M21.45,18.66,14.68,5.13a3,3,0,0,0-5.36,0L2.55,18.66A3,3,0,0,0,5.24,23H18.76a3,3,0,0,0,2.69-4.34Zm-8.74.05A1.05,1.05,0,0,1,12,19a1,1,0,1,1,.71-.29ZM13,15a1,1,0,0,1-2,0V10a1,1,0,0,1,2,0Z",
    transform: "translate(-2.234 -3.478)",
    fill: "#da8d52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseMessageIcon);
export default __webpack_public_path__ + "static/media/collapse_message_icon.05b4bb9b56d1bd0b81a9e0c9bce777f8.svg";
export { ForwardRef as ReactComponent };